<template>
    <v-dialog v-model="editMealPlanDialog" max-width="576" persistent>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="setMealPlan()" :color="successColor" icon>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Edit</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Edit Meal Plan
            </v-card-title>
            <v-card-text>
                <v-form ref="editMealPlan" v-model="valid" lazy-validation>
                    <v-text-field v-model="currentMealPlan.mealPlan" clearable label="Meal Plan" :rules="mealPlanRules"
                        required>
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" class="white--text" :color="successColor" :disabled="!valid"
                    @click="editMealPlan()">
                    Save
                </v-btn>
                <v-btn :color="warningColor" @click="closeDialog()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'meal-plan-edit',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            currentMealPlan: '',
            editMealPlanDialog: false,
            mealPlanRules: [
                v => !!v || 'Meal plan is required',
                v => (v && v.length >= 2) || 'Meal plan must be more than 2 characters',
            ],
            valid: true
        }
    },
    methods: {
        closeDialog() {
            this.editMealPlanDialog = false;
        },
        editMealPlan() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            if (this.$refs.editMealPlan.validate()) {
                // Parse array into string
                formData.append('data', JSON.stringify(this.currentMealPlan));
                formData.append('mode', 'updateEntity');
                formData.append('type', 'MealPlans');

                // Loading icon
                this.$refs.confirmBtn.loading = true;

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Return JSON response
                        return response.json();
                    })
                    .then(function (json) {
                        // Success result
                        if (json.result.match(/OK/i)) {
                            that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentMealPlan.mealPlan} has been successfully updated.`, true);
                        } else if (json.message.match(/UNAUTHORIZED/i)) {
                            that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                        } else {
                            that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentMealPlan.mealPlan} could not be updated. Please contact your system administrator.`, true);
                        }

                        that.$emit('refreshData');
                        that.closeDialog();
                        that.$refs.confirmBtn.loading = false;
                    })
                    .catch(function () {
                        that.$emit('refreshData');
                        that.closeDialog();
                        that.$refs.confirmBtn.loading = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        },
        setMealPlan() {
            this.currentMealPlan = {
                ...this.item
            };

            if (this.$refs.editMealPlan) {
                this.$refs.editMealPlan.resetValidation();
            }
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>